__turbopack_context__.v({
  "footer": "CampaignView-module__J3IOUG__footer",
  "grid": "CampaignView-module__J3IOUG__grid",
});
